(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-story"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.reviews-carousel').forEach(function (section) {
  var track = section.querySelector('.reviews-carousel__track');
  var cards = section.querySelectorAll('.reviews-carousel__card');
  var prevButton = section.querySelector('[data-direction="prev"]');
  var nextButton = section.querySelector('[data-direction="next"]');

  if (!track || !cards.length) return;

  var isRTL = getComputedStyle(section).direction === 'rtl';
  var index = 0;

  function update() {
    var cardWidth = cards[0].getBoundingClientRect().width;
    var gap = 24;
    var offset = index * (cardWidth + gap);
    track.style.transform = 'translateX(' + (isRTL ? offset : -offset) + 'px)';
  }

  function next() {
    index = Math.min(index + 1, cards.length - 1);
    update();
  }

  function prev() {
    index = Math.max(index - 1, 0);
    update();
  }

  if (nextButton) nextButton.addEventListener('click', isRTL ? prev : next);
  if (prevButton) prevButton.addEventListener('click', isRTL ? next : prev);

  window.addEventListener('resize', update);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fragrance-quiz"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[id^="NoteQuizTrigger-"], [id^="NoteQuizModal-"]').forEach(function (el) {
  document.body.appendChild(el);
});

function noteQuizLockScroll() {
  document.documentElement.style.overflow = 'hidden';
}

function noteQuizUnlockScroll() {
  document.documentElement.style.overflow = '';
}

document.querySelectorAll('[id^="NoteQuizTrigger-"]').forEach(function (trigger) {
  var sectionId = trigger.id.replace('NoteQuizTrigger-', '');
  var modal = document.getElementById('NoteQuizModal-' + sectionId);
  var closeBtn = document.getElementById('NoteQuizClose-' + sectionId);
  var submitBtn = document.getElementById('NoteQuizSubmit-' + sectionId);
  var backBtn = document.getElementById('NoteQuizBack-' + sectionId);
  var stepSelect = document.getElementById('NoteQuizStepSelect-' + sectionId);
  var stepResults = document.getElementById('NoteQuizStepResults-' + sectionId);
  var grid = document.getElementById('NoteQuizGrid-' + sectionId);
  var countEl = document.getElementById('NoteQuizCount-' + sectionId);
  var emptyEl = document.getElementById('NoteQuizEmpty-' + sectionId);
  var source = document.getElementById('NoteQuizSource-' + sectionId);
  var optionButtons = modal.querySelectorAll('[data-note-option]');
  var selected = new Set();

  function updateSubmitState() {
    submitBtn.disabled = selected.size === 0;
  }

  optionButtons.forEach(function (option) {
    option.addEventListener('click', function () {
      var noteId = option.getAttribute('data-note-id');
      if (selected.has(noteId)) {
        selected.delete(noteId);
        option.setAttribute('aria-pressed', 'false');
      } else {
        selected.add(noteId);
        option.setAttribute('aria-pressed', 'true');
      }
      updateSubmitState();
    });
  });

  function buildResults() {
    grid.innerHTML = '';
    var seen = new Set();
    var total = 0;

    selected.forEach(function (noteId) {
      var collectionEl = source.querySelector('[data-note-id="' + noteId + '"]');
      if (!collectionEl) {
        return;
      }
      collectionEl.querySelectorAll('.note-quiz-card').forEach(function (card) {
        var productId = card.getAttribute('data-product-id');
        if (seen.has(productId)) {
          return;
        }
        seen.add(productId);
        grid.appendChild(card.cloneNode(true));
        total += 1;
      });
    });

    countEl.textContent = total + (total === 1 ? ' منتج' : ' منتجات');
    emptyEl.hidden = total !== 0;
    grid.hidden = total === 0;
  }

  trigger.addEventListener('click', function () {
    modal.showModal();
    noteQuizLockScroll();
  });

  modal.addEventListener('close', function () {
    noteQuizUnlockScroll();
  });

  closeBtn.addEventListener('click', function () {
    modal.close();
  });

  modal.addEventListener('click', function (event) {
    if (event.target === modal) {
      modal.close();
    }
  });

  submitBtn.addEventListener('click', function () {
    buildResults();
    stepSelect.hidden = true;
    stepResults.hidden = false;
  });

  backBtn.addEventListener('click', function () {
    stepResults.hidden = true;
    stepSelect.hidden = false;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
class HeroCarousel {
  constructor(root) {
    this.root = root;
    this.slides = Array.from(root.querySelectorAll('.hero-carousel__slide'));
    this.dots = Array.from(root.querySelectorAll('.hero-carousel__dot'));
    this.prevBtn = root.querySelector('.hero-carousel__arrow--prev');
    this.nextBtn = root.querySelector('.hero-carousel__arrow--next');
    this.autoplayMs = parseInt(root.dataset.autoplay, 10) || 6000;
    this.current = 0;
    this.timer = null;

    if (this.slides.length < 2) return;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.dotIndex, 10));
        this.restart();
      });
    });

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.goTo(this.current - 1);
        this.restart();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.goTo(this.current + 1);
        this.restart();
      });
    }

    this.root.addEventListener('mouseenter', () => this.stop());
    this.root.addEventListener('mouseleave', () => this.start());
    this.root.addEventListener('focusin', () => this.stop());
    this.root.addEventListener('focusout', () => this.start());

    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchDeltaX = 0;
    this.isSwiping = false;

    this.root.addEventListener('touchstart', (e) => this.onTouchStart(e), { passive: true });
    this.root.addEventListener('touchmove', (e) => this.onTouchMove(e), { passive: false });
    this.root.addEventListener('touchend', () => this.onTouchEnd());

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stop();
      } else {
        this.start();
      }
    });

    this.start();
  }

  goTo(index) {
    const total = this.slides.length;
    const nextIndex = (index + total) % total;
    this.slides[this.current].classList.remove('is-active');
    this.dots[this.current] && this.dots[this.current].classList.remove('is-active');
    this.dots[this.current] && this.dots[this.current].setAttribute('aria-selected', 'false');

    this.current = nextIndex;

    this.slides[this.current].classList.add('is-active');
    this.dots[this.current] && this.dots[this.current].classList.add('is-active');
    this.dots[this.current] && this.dots[this.current].setAttribute('aria-selected', 'true');
  }

  onTouchStart(e) {
    this.touchStartX = e.touches[0].clientX;
    this.touchStartY = e.touches[0].clientY;
    this.touchDeltaX = 0;
    this.isSwiping = false;
    this.stop();
  }

  onTouchMove(e) {
    const touch = e.touches[0];
    const deltaX = touch.clientX - this.touchStartX;
    const deltaY = touch.clientY - this.touchStartY;

    if (!this.isSwiping) {
      if (Math.abs(deltaX) < Math.abs(deltaY)) return;
      this.isSwiping = true;
    }

    this.touchDeltaX = deltaX;
    e.preventDefault();
  }

  onTouchEnd() {
    const threshold = 40;

    if (this.isSwiping) {
      if (this.touchDeltaX <= -threshold) {
        this.goTo(this.current + 1);
      } else if (this.touchDeltaX >= threshold) {
        this.goTo(this.current - 1);
      }
    }

    this.isSwiping = false;
    this.touchDeltaX = 0;
    this.start();
  }

  start() {
    if (this.timer || this.autoplayMs <= 0) return;
    this.timer = setInterval(() => this.goTo(this.current + 1), this.autoplayMs);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  restart() {
    this.stop();
    this.start();
  }
}

document.querySelectorAll('.hero-carousel').forEach((root) => new HeroCarousel(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrival-spotlight"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.new-arrival').forEach(function (section) {
  var mainImage = section.querySelector('.new-arrival__image');
  var thumbs = section.querySelectorAll('.new-arrival__thumb');

  if (!thumbs.length || !mainImage) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var thumbImage = thumb.querySelector('.new-arrival__thumb-image');
      if (!thumbImage) return;

      var fullSrc = thumbImage.getAttribute('src').replace(/width=\d+/, 'width=1200');

      mainImage.style.opacity = '0';

      window.setTimeout(function () {
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = fullSrc;
        mainImage.style.opacity = '1';
      }, 150);

      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  mainImage.style.transition = mainImage.style.transition + ', opacity 0.2s ease';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-reviews"] && !Shopify.designMode) return;
  try {
    
function initSpotlightGallery(section) {
  var mainImage = section.querySelector('.new-arrival__image');
  var thumbs = section.querySelectorAll('.new-arrival__thumb');

  if (!thumbs.length || !mainImage) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var fullSrc = thumb.getAttribute('data-full');
      if (!fullSrc) return;

      mainImage.style.opacity = '0';

      window.setTimeout(function () {
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = fullSrc;
        mainImage.style.opacity = '1';
      }, 150);

      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
}

document.querySelectorAll('.new-arrival').forEach(initSpotlightGallery);

document.addEventListener('shopify:section:load', function (event) {
  var section = event.target.querySelector('.new-arrival');
  if (section) initSpotlightGallery(section);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testHero"] && !Shopify.designMode) return;
  try {
    
class HeroCarousel {
  constructor(root) {
    this.root = root;
    this.slides = Array.from(root.querySelectorAll('.hero-carousel__slide'));
    this.dots = Array.from(root.querySelectorAll('.hero-carousel__dot'));
    this.prevBtn = root.querySelector('.hero-carousel__arrow--prev');
    this.nextBtn = root.querySelector('.hero-carousel__arrow--next');
    this.autoplayMs = parseInt(root.dataset.autoplay, 10) || 6000;
    this.current = 0;
    this.timer = null;

    if (this.slides.length < 2) return;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.dotIndex, 10));
        this.restart();
      });
    });

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.goTo(this.current - 1);
        this.restart();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.goTo(this.current + 1);
        this.restart();
      });
    }

    this.root.addEventListener('mouseenter', () => this.stop());
    this.root.addEventListener('mouseleave', () => this.start());
    this.root.addEventListener('focusin', () => this.stop());
    this.root.addEventListener('focusout', () => this.start());

    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchDeltaX = 0;
    this.isSwiping = false;

    this.root.addEventListener('touchstart', (e) => this.onTouchStart(e), { passive: true });
    this.root.addEventListener('touchmove', (e) => this.onTouchMove(e), { passive: false });
    this.root.addEventListener('touchend', () => this.onTouchEnd());

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stop();
      } else {
        this.start();
      }
    });

    this.start();
  }

  restartDotAnimation(dot) {
    const fill = dot && dot.querySelector('.hero-carousel__dot-fill');
    if (!fill) return;
    fill.style.animation = 'none';
    void fill.offsetWidth;
    fill.style.animation = '';
  }

  goTo(index) {
    const total = this.slides.length;
    const nextIndex = (index + total) % total;
    this.slides[this.current].classList.remove('is-active');
    this.dots[this.current] && this.dots[this.current].classList.remove('is-active');
    this.dots[this.current] && this.dots[this.current].setAttribute('aria-selected', 'false');

    this.current = nextIndex;

    this.slides[this.current].classList.add('is-active');
    if (this.dots[this.current]) {
      this.dots[this.current].classList.add('is-active');
      this.dots[this.current].setAttribute('aria-selected', 'true');
      this.restartDotAnimation(this.dots[this.current]);
    }
  }

  onTouchStart(e) {
    this.touchStartX = e.touches[0].clientX;
    this.touchStartY = e.touches[0].clientY;
    this.touchDeltaX = 0;
    this.isSwiping = false;
    this.stop();
  }

  onTouchMove(e) {
    const touch = e.touches[0];
    const deltaX = touch.clientX - this.touchStartX;
    const deltaY = touch.clientY - this.touchStartY;

    if (!this.isSwiping) {
      if (Math.abs(deltaX) < Math.abs(deltaY)) return;
      this.isSwiping = true;
    }

    this.touchDeltaX = deltaX;
    e.preventDefault();
  }

  onTouchEnd() {
    const threshold = 40;

    if (this.isSwiping) {
      if (this.touchDeltaX <= -threshold) {
        this.goTo(this.current + 1);
      } else if (this.touchDeltaX >= threshold) {
        this.goTo(this.current - 1);
      }
    }

    this.isSwiping = false;
    this.touchDeltaX = 0;
    this.start();
  }

  start() {
    this.root.classList.remove('is-paused');
    if (this.timer || this.autoplayMs <= 0) return;
    this.timer = setInterval(() => this.goTo(this.current + 1), this.autoplayMs);
  }

  stop() {
    this.root.classList.add('is-paused');
    clearInterval(this.timer);
    this.timer = null;
  }

  restart() {
    this.stop();
    this.start();
    this.restartDotAnimation(this.dots[this.current]);
  }
}

document.querySelectorAll('.hero-carousel').forEach((root) => new HeroCarousel(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel-slider"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-vc]').forEach(function (root) {
  var track = root.querySelector('[data-vc-track]');
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-vc-slide]'));
  var prevBtn = root.querySelector('[data-vc-prev]');
  var nextBtn = root.querySelector('[data-vc-next]');
  var autoplayMs = parseInt(root.dataset.vcAutoplay, 10) || 0;
  var autoplayTimer = null;

  if (!track || !slides.length) return;

  function slideStep() {
    var slide = slides[0];
    var gap = parseFloat(getComputedStyle(track).columnGap || 0);
    return slide.getBoundingClientRect().width + gap;
  }

  function updateNavState() {
    if (!prevBtn || !nextBtn) return;
    var atStart = track.scrollLeft <= 1;
    var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
    prevBtn.disabled = atStart;
    nextBtn.disabled = atEnd;
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -slideStep(), behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: slideStep(), behavior: 'smooth' });
    });
  }

  track.addEventListener('scroll', function () {
    window.requestAnimationFrame(updateNavState);
  }, { passive: true });
  updateNavState();

  slides.forEach(function (slide) {
    var video = slide.querySelector('[data-vc-video]');
    var soundBtn = slide.querySelector('[data-vc-sound]');
    if (!video) return;

    if (soundBtn) {
      soundBtn.addEventListener('click', function () {
        var muted = video.muted;
        slides.forEach(function (s) {
          var v = s.querySelector('[data-vc-video]');
          var b = s.querySelector('[data-vc-sound]');
          if (v) v.muted = true;
          if (b) b.setAttribute('aria-pressed', 'false');
        });
        video.muted = !muted;
        soundBtn.setAttribute('aria-pressed', String(!muted));
      });
    }
  });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var video = entry.target.querySelector('[data-vc-video]');
      if (!video) return;
      if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
        video.play().catch(function () {});
      } else {
        video.pause();
      }
    });
  }, { root: track, threshold: [0, 0.6, 1] });

  slides.forEach(function (slide) {
    observer.observe(slide);
  });

  if (autoplayMs > 0) {
    autoplayTimer = setInterval(function () {
      var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
      if (atEnd) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: slideStep(), behavior: 'smooth' });
      }
    }, autoplayMs);

    root.addEventListener('mouseenter', function () {
      clearInterval(autoplayTimer);
    });
    root.addEventListener('mouseleave', function () {
      autoplayTimer = setInterval(function () {
        var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
        if (atEnd) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: slideStep(), behavior: 'smooth' });
        }
      }, autoplayMs);
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
